import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

const BASE = serviceName + '/learning/course'

export function uploadCourseCover(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: serviceName + '/learning/course/uploadCover',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function uploadCourseMaterial(files) {
  const formData = new FormData()
  const list = Array.isArray(files) ? files : [files]
  list.forEach(file => {
    formData.append('files', file)
  })
  return request({
    url: serviceName + '/learning/material/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function uploadVideo(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: serviceName + '/learning/video/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export function getCoursePage(data) {
  return request({
    url: BASE + '/page',
    method: 'post',
    data,
  })
}

export function getCourseDetail(id) {
  return request({
    url: BASE + '/detail/' + id,
    method: 'get',
  })
}

export function addCourse(data) {
  return request({
    url: BASE + '/add',
    method: 'post',
    data,
  })
}

export function updateCourse(data) {
  return request({
    url: BASE + '/update',
    method: 'post',
    data,
  })
}

export function deleteCourse(id) {
  return request({
    url: BASE + '/delete/' + id,
    method: 'post',
  })
}

export function setCourseStatus(id, status) {
  return request({
    url: BASE + '/status/' + id,
    method: 'post',
    params: { status },
  })
}